interface IDashboardMenus {
  title: string
  icon: string
  path: string
  description?: string
  hidden?: boolean
}

// `title`/`name`/`description` hold i18n keys (menus.*) — translate at render time
export const SIDEBAR_EXPAND_WIDTH = 280;
export const SIDEBAR_COLLAPSED_WIDTH = 72;
export const DOWNLOAD_URL = 'https://geekfun.club/download';
export const PRODUCT_URLS = {
  dockit: 'https://www.geekfun.club/products/dockit/',
  sqlkit: 'https://www.geekfun.club/products/sqlkit/',
  dataStudioAgent: 'https://www.geekfun.club/products/data-studio-agent/',
  serverlessinsight: 'https://serverlessinsight.com/',
} as const;
export const APP_MENU: Record<string, { name: string, routes: IDashboardMenus[] }> = {
  main: {
    name: 'menus.core',
    routes: [
      {
        title: 'menus.dashboard',
        icon: 'LayoutDashboard',
        path: '/home',
      }
    ],
  },
  settings: {
    name: 'menus.general',
    routes: [
      {
        path: '/home/user',
        title: 'menus.user',
        icon: 'Users',
        description: 'menus.userDescription'
      },
      {
        path: '/home/settings',
        title: 'menus.settings',
        icon: 'Settings2',
        description: 'menus.settingsDescription'
      },
      {
        path: '/home/devices',
        title: 'menus.devices',
        icon: 'MonitorSmartphone',
        description: 'menus.devicesDescription'
      },
    ],
  },
};

export const globalSearch = {

};
